export * from './angular-service-config.provider';
